import { useWfAlertHistoryStore } from 'src/api/wf/stores/WfAlertHistoryStore';
import useWfAlertHistoryService from 'src/api/wf/service/WfAlertHistoryService';
import { useEffect, useState } from 'react';
import WF_Header from '../../common/header/WfHeader';
import { WfHistoryDetail } from 'src/api/wf/models/WfHistoryDetail';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';

const toDisplayText = (value: unknown) => {
  if (value === null || value === undefined) return '';

  const trimmed = String(value).trim();
  if (trimmed === '' || trimmed === 'null') return '';

  return trimmed;
};

function WF_4_7_4_AlertHistoryDetails() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchHistoryDetails } = useWfAlertHistoryService();
  const { selectedHistory } = useWfAlertHistoryStore();

  const [historyDetails, setHistoryDetails] = useState<WfHistoryDetail[]>([]);

  useEffect(() => {
    const loadHistoryDetails = async () => {
      const _historyDetails = await fetchHistoryDetails(selectedHistory?.alertHistoryId ?? 0);
      setHistoryDetails(_historyDetails);
    };

    loadHistoryDetails();
  }, [selectedHistory?.alertHistoryId, fetchHistoryDetails]);
  const fields: (keyof WfHistoryDetail)[] = [
    'alertCategory',
    'errorDateTime',
    'recoveryDateTime',
    'alertDateTime',
    'dispatchDateTime',
    'arrivalDateTime',
    'completionDateTime',
    'recoveryAlertStatus',
    'alertComment',
    'receivedContent',
    'callerName',
    'callerPhoneNumber',
    'callerCategory',
    'reportTo1Name',
    'reportTo1Contact',
    'reportTo1Category',
    'reportTo2Name',
    'reportTo2Contact',
    'reportTo2Category',
    'directCall',
  ];

  const renderValue = (
    key: keyof WfHistoryDetail,
    value: WfHistoryDetail[keyof WfHistoryDetail]
  ) => {
    if (key === 'recoveryAlertStatus') {
      return value ? t('wf.alertHistory.checkMark') : t('wf.alertHistory.crossMark');
    }

    const displayText = toDisplayText(value);
    if (displayText === '') return '';

    if (key.toString().includes('DateTime')) {
      return formatJpnDate({ iso: displayText });
    }
    return displayText;
  };

  return (
    <div className="bg-gray-100">
      <WF_Header />
      <div className="flex-1 overflow-y-auto bg-white">
        <div className="flex flex-col gap-2">
          {historyDetails.length === 0 && (
            <div className="px-4 py-6 text-sm text-gray-500">{t('wf.common.noResults')}</div>
          )}
          {historyDetails.map((section) => (
            <div key={section.id}>
              <div
                className="sticky top-0 z-10 border-b border-gray-300 bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-800"
                style={{ top: 0 }}
              >
                #{section.id}
              </div>

              <div className="divide-y divide-gray-200">
                {fields.map((key) => (
                  <div key={key} className="px-4 py-3">
                    <div className="text-sm text-gray-900">{t(`wf.alertHistory.${key}`)}</div>
                    <div className="text-sm text-gray-600">{renderValue(key, section[key])}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="p-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full rounded-sm border border-gray-400 bg-gray-100 px-4 py-2 text-sm shadow-sm hover:bg-gray-200"
          >
            {t('wf.common.back')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WF_4_7_4_AlertHistoryDetails;
